<template>
  <div class="ku-make">
    <div class="ku-make-tip">请对 "{{ kuinfo.name }}" 项目进行制作设置</div>

    <div class="ku-make-row">
      <span>制作数量</span>
      <el-input-number v-model="make_num" :min="1" :max="10" size="small"></el-input-number>
    </div>

    <div class="ku-make-sub">其他设置（请了解后再开启）</div>

    <div class="ku-make-row">
      <div class="ku-make-label">
        固定判断时间
        <div class="ku-make-hint">片段长可选</div>
      </div>
      <div class="ku-make-ctl">
        <el-select v-model="gdsj_time" placeholder="请选择" size="small" style="width: 72px;" v-if="gdtime_open">
          <el-option v-for="item in all_time" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <span v-if="gdtime_open" class="ku-make-unit">秒</span>
        <el-switch v-model="gdtime_open" active-color="#13ce66"></el-switch>
      </div>
    </div>

    <div class="ku-make-row">
      <div class="ku-make-label">
        片段掐头去尾
        <div class="ku-make-hint">建议原创拍摄视频</div>
      </div>
      <div class="ku-make-ctl">
        <el-select v-model="qtqw_time" placeholder="请选择" size="small" style="width: 72px;" v-if="qtqw_open">
          <el-option v-for="item in all_time" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <span v-if="qtqw_open" class="ku-make-unit">秒</span>
        <el-switch v-model="qtqw_open" active-color="#13ce66"></el-switch>
      </div>
    </div>

    <div class="ku-make-row">
      <div class="ku-make-label">
        随机视频
        <div class="ku-make-hint">可能会有重复画面</div>
      </div>
      <el-switch v-model="sjpd_open" active-color="#13ce66"></el-switch>
    </div>

    <div class="ku-make-row">
      <div class="ku-make-label">
        随机镜像
        <div class="ku-make-hint">对画面片段随机镜像</div>
      </div>
      <el-switch v-model="sjjx_open" active-color="#13ce66"></el-switch>
    </div>

    <div class="ku-make-footer">
      <el-button type="primary" size="medium" :loading="submitting" @click="ks">开始制作</el-button>
    </div>
  </div>
</template>

<script>
// 2.0 版制作设置：逻辑同 1.0（User/Ku_makevideo.vue），接口改走新后端 /ku/make，
// 并去掉原来用 $parent.$parent 回调父组件的深链，改为 $emit。
export default {
  name: 'User2KuMakevideo',
  props: {
    kuinfo: { type: [Object, Array], default: () => ({}) }
  },
  data() {
    return {
      make_num: 1,
      gdtime_open: false,
      qtqw_open: false,
      sjpd_open: false,
      sjjx_open: false,
      qtqw_time: '0.1',
      gdsj_time: '0.1',
      submitting: false,
      all_time: ['0.1', '0.2', '0.4', '0.6', '0.8', '1.0', '1.2', '1.4', '1.6',
        '1.8', '2.0', '2.2', '2.4', '2.6', '2.8', '3.0']
    }
  },
  methods: {
    ks() {
      if (this.submitting) return
      this.submitting = true
      this.$ajax.post('api/v1/users/ku/make', {
        kuid: this.kuinfo.id,
        kuname: this.kuinfo.name,
        num: this.make_num,
        gdtime: this.gdtime_open ? this.gdsj_time : 0,
        qtqw: this.qtqw_open ? this.qtqw_time : 0,
        hmsj: this.sjpd_open ? 1 : 0,
        hmjx: this.sjjx_open ? 1 : 0
      }).then(res => {
        const body = res.data || {}
        if (body.status == 200) {
          this.$msg.success(body.msg)
          this.$emit('done')
        } else {
          this.$msg.error(body.msg)
        }
      }).catch(() => {
        this.$msg.error('提交失败，请重试')
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style scoped>
.ku-make-tip {
  margin-bottom: 18px;
  color: #64748b;
  font-size: 13px;
}

.ku-make-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
}

.ku-make-sub {
  margin-top: 24px;
  color: #94a3b8;
  font-size: 13px;
}

.ku-make-label {
  color: #334155;
  font-size: 13px;
}

.ku-make-hint {
  color: #94a3b8;
  font-size: 12px;
}

.ku-make-ctl {
  display: flex;
  flex: none;
  align-items: center;
  gap: 8px;
}

.ku-make-unit {
  color: #94a3b8;
  font-size: 13px;
}

.ku-make-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 26px;
}

@media (max-width: 480px) {
  .ku-make-row {
    align-items: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User2/Ku_makevideo.vue